import React, { useContext, useCallback } from 'react'
import _ from 'lodash'
import { useDispatch } from 'react-redux'
import { v4 } from 'uuid'
import { FormProvider, useForm } from 'react-hook-form'

import ActionSelect from '../templates/action-select/ActionSelect'
import { StepContext } from '../../../../containers/contexts'
import { updateAction, addAction, setFlowHistory } from 'Actions/flow'
import actionDetails from '../meta.json'
import { findgoToStep } from '../../utils/findGoToStep'

const ACTION_TYPE = 'happyfoxchat_contact_details_form'

const PrechatForm = ({ actionId, cancelFn = _.noop, deleteFn = _.noop, mode }) => {
  const { step, stepId, row } = useContext(StepContext)
  const dispatch = useDispatch()
  const isEditMode = mode === 'edit'

  const settings = _.get(step, 'settings', {})
  const actionSetting = _.get(settings, `${actionId}`, {
    type: ACTION_TYPE
  })

  const formMethods = useForm({
    defaultValues: {
      action: {
        ...actionSetting.action,
        type: 'goToStep'
      }
    }
  })

  const { handleSubmit } = formMethods

  const update = useCallback(
    (data) => {
      dispatch(
        updateAction({
          stepId,
          actionId,
          setting: {
            type: ACTION_TYPE,
            action: data.action
          }
        })
      )
      dispatch(setFlowHistory({ goToStep: findgoToStep(data.action), row }))
    },
    [dispatch, actionId, stepId, row]
  )

  const create = useCallback(
    (data) => {
      dispatch(
        addAction({
          stepId,
          actionId: v4(),
          setting: {
            type: ACTION_TYPE,
            action: data.action
          }
        })
      )
      dispatch(setFlowHistory({ goToStep: findgoToStep(data.action), row }))
    },
    [dispatch, stepId, row]
  )

  const handleFormSubmit = useCallback(
    (data) => {
      if (isEditMode) {
        update(data)
      } else {
        create(data)
      }
      cancelFn()
    },
    [isEditMode, cancelFn, create, update]
  )

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <div className='label h5'>{actionDetails[ACTION_TYPE].name}</div>
      <FormProvider {...formMethods}>
        <ActionSelect showTypeSelector={false} />
      </FormProvider>
      <div className='options'>
        <button className='button-primary small save' type='submit'>
          Save
        </button>
        <button className='btn cancel' type='button' onClick={cancelFn}>
          Cancel
        </button>
        {isEditMode && (
          <button className='btn delete' type='button' onClick={deleteFn}>
            Delete
          </button>
        )}
      </div>
    </form>
  )
}

export default PrechatForm
